import { HTTP } from '../../utils'

export const populateCatalog = (uuid) => {
  return HTTP().get('/catalog/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const doCsvUploadForCatalog = (institutionId, createdByUuid, folderId, fileData) => {
  if (!institutionId || !createdByUuid || !folderId || !fileData) {
    return
  }
  let url = '/catalog/bulkUpload?createdByUuid=' + createdByUuid + '&institutionId=' + institutionId + '&folderId=' + folderId
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const doCsvUploadForCatalogSkillTag = (data) => {
  return HTTP().post('/catalog/applyBulkSkillTag', data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCatalogs = (page, count, keyword) => {
  let url = 'catalog/list?page=' + page + '&count=' + count
  if (keyword) {
    url += '&title=' + keyword
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteAllCatalogs = () => {
  return HTTP().delete('catalog/all')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/catalog/api.js